import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface ListCodeMovementProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: string, item?: ItemVM) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const ListCodeMovementComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  label = 'Codice Movimento',
  id = 'code-movement',
}: ListCodeMovementProps): React.ReactElement => {
  const [documentCode] = useHttpFetch<HttpResponseList<string>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-operazione/codice-motivo`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<string>>) => {
        const { data } = response;
        return data?.payload?.list?.map((item) => ({
          id: item ? item.trim() : '',
          value: item ? item.trim() : '',
        }));
      },
    }
  );

  const dataSet = (documentCode.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`${id}-label`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) =>
          onChange(
            event.target.value,
            dataSet.find((el) => el.value === event.target.value)
          )
        }
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {dataSet.map((element: ItemVM) => (
          <MenuItem key={element.id} value={element.value}>
            {element.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListCodeMovementComponent.displayName = 'List code movement component';

const ListCodeMovement = memo(ListCodeMovementComponent);

export default ListCodeMovement as typeof ListCodeMovementComponent;
